import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import {Label} from 'lib/ui/typography'
import {useLeftyTemplate} from 'Event/template/Lefty'
import {useAttendeeVariables} from 'Event'
import HTMLEditor, {HTMLEditorContainer} from 'lib/ui/form/HTMLEditor'

export default function Settings(props: {control: UseFormMethods['control']}) {
  const {control} = props
  const template = useLeftyTemplate()
  const {welcomeText} = template

  const v = useAttendeeVariables()

  return (
    <>
      <Label>Text</Label>
      <HTMLEditorContainer>
        <Controller
          name="welcomeText"
          control={control}
          defaultValue={v(welcomeText)}
          render={({value, onChange}) => (
            <HTMLEditor
              data={value || ''}
              onChange={onChange}
              aria-label="dashboard welcome text"
            />
          )}
        />
      </HTMLEditorContainer>
    </>
  )
}
